export default __webpack_public_path__ + "static/media/pdf-file.5d91b148.svg";